import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductRepository from "src/repository/ProductRepository";

export const getProductList = createAsyncThunk('productListing_getProductList', async (params) => {
    return await new ProductRepository().getProductList(params);
});

const slice = createSlice({
    name: "ProductListing",
    initialState: {
        productListWithFacet: {},
        category_filter_applied_status: false,
        append_facade_options_status: false,
        master_data_only_products_list: {},
    },
    reducers: {
        set_category_filter_applied_status: {
            reducer: (state, action) => {
                state.category_filter_applied_status = action.payload.status
            },
        },
        set_append_facade_options_status: {
            reducer: (state, action) => {
                state.append_facade_options_status = action.payload.status
            },
        },
        set_product_master_data: {
            reducer: (state, action) => {
                if (action.payload.value && action.payload.value.length) {
                    action.payload.value.map((v) => {
                        state.master_data_only_products_list[v.ERPPartNumber] = v
                        state.master_data_only_products_list[v.ItemNumber] = v
                    });
                }
            },
        },
    },
    extraReducers: {
        [getProductList.fulfilled]: (state, { payload }) => {
            state.productListWithFacet = payload;
            return state;
        },
    },
})

export let { setAll, set_category_filter_applied_status, set_append_facade_options_status, set_product_master_data } = slice.actions;

export default slice.reducer;
